<template>
    <!--เบิกล่วงหน้า--->
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        v-model="search.employee"
                        class="form-control border-0"
                        :options="employeeAll"
                        select-label=""
                        deselectLabel=""
                        placeholder="เลือกพนักงาน"
                        :custom-label="employeeLabel"
                        track-by="id">
                    </multiselect>
                    <date-picker
                        v-model="search.date"
                        format="DD/MM/YYYY"
                        lang="en"
                        placeholder="วันที่เบิก">
                    </date-picker>&nbsp;&nbsp;

                    <button class="btn btn-success my-2 my-sm-0"
                            @click="searchAdvancePayment"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;
                    <button class="btn btn-warning my-2 my-sm-0"
                            @click="createAdvancePayment"
                            type="button">
                        <icon name="plus"></icon>
                        ตั้งเบิก
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">ยอดเงินเบิกล่วงหน้า</th>
                    <th scope="col">ยอดเงินจ่ายคืนสะสม</th>
                    <th scope="col">วันที่เบิก</th>
                    <th scope="col">รอบการหัก</th>
                    <th scope="col">สถานะการคืนเงิน</th>
                    <th scope="col">ผู้บันทึก</th>
                    <th scope="col">แก้ไข</th>
                    <th scope="col">บันทึกการจ่ายคืน</th>
                    <!--                    <th scope="col">แก้ไข</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in AdvancePaymentList">
                    <td>{{ ((dataPaginate.current_page - 1) * 10) + (index + 1) }}</td>
                    <td>
                        <template v-if="data.employee">
                            {{ data.employee.employee_no }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.employee">
                            {{ data.employee.first_name }} {{ data.employee.last_name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.total_advance_payment | currency }}</td>
                    <td>{{ data.sum_amount_return_per_month | currency }}</td>
                    <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                    <td>
                        <span v-if="data.paid == 1">วีค 1</span>
                        <span v-else-if="data.paid == 2">วีค 2</span>
                        <span v-else-if="data.paid == 3">เสมอ</span>
                        <span v-else>-</span>
                    </td>
                    <td>
                        <template v-if="data.balance_advance_payment != 0">
                            <span style="color: red">อยู่ระหว่างการชำระ</span>
                        </template>
                        <template v-else>
                            <span style="color: green">เสร็จสิ้น</span>
                        </template>
                    </td>
                    <td>
                        {{ data.recorder }}
                    </td>
                    <td>
                        <button class="btn btn-primary"
                                v-if="canViewSuperAdmin && data.balance_advance_payment != 0"
                                :disabled="!data.employee"
                                typeof="button"
                                @click="showPaymentDetails(index)">
                            แก้ไข
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-primary"
                                :disabled="!data.employee"
                                typeof="button"
                                @click="showAdvancePaymentDetails(data.id)">
                            ดูข้อมูล
                        </button>
                    </td>
                    <!--                    <td>-->
                    <!--                        <template v-if="data.balance_advance_payment != 0 && !data.employee">-->
                    <!--                            <a  @click="editAdvancePayment(data.id)">-->
                    <!--                                <icon name="pencil-alt"></icon>-->
                    <!--                            </a>-->
                    <!--                        </template>-->
                    <!--                        <template v-else :disabled="1">-->
                    <!--                            <a>-->
                    <!--                                <icon name="pencil-alt"-->
                    <!--                                      style="color: grey">-->
                    <!--                                </icon>-->
                    <!--                            </a>-->
                    <!--                        </template>-->
                    <!--                    </td>-->
                </tr>
                </tbody>
            </table>
        </div>
        <!--b-modal-->
        <b-modal size="md" hide-header hide-footer ref="advance_payment">
            <advance-payment-modal @submit="saveAdvancePayment" :optionEmployee="employeeAll">
            </advance-payment-modal>
        </b-modal>
        <b-modal size="md" hide-header hide-footer ref="advance_payment_edit">
            <advance-payment-edit-modal @submit="onEditAdvancePayment" :item="item" :optionEmployee="employeeAll">
            </advance-payment-edit-modal>
        </b-modal>
        <b-modal size="lg" hide-header hide-footer ref="advance_payment_details">
            <advance-payment-form @submit="showAdvancePaymentDetail" :item="item" :optionEmployee="employeeAll">
            </advance-payment-form>
        </b-modal>
        <div v-if="AdvancePaymentList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getAdvancePaymentList">
            </vue-pagination>
        </div>
        <br>
        <!--        <pre class="alert alert-primary">{{AdvancePaymentList}}</pre>-->
    </div>
</template>

<script>
import AdvancePaymentModal from "./Modal/AdvancePaymentModal";
import AdvancePaymentForm from "./AdvancePaymentForm";
import {mapState} from "vuex"
import moment from "moment";
import VuePagination from "../../../Pagination";
import Multiselect from "vue-multiselect"
import DatePicker from 'vue2-datepicker'
import {canViewSuperAdmin} from "@/util/Permissions";
import AdvancePaymentEditModal from "@/components/Person/HR/SalaryPayment/Modal/AdvancePaymentEditModal.vue";

export default {
    name: "advance-payment",
    components: {
        AdvancePaymentEditModal,
        AdvancePaymentModal,
        AdvancePaymentForm,
        Multiselect,
        VuePagination,
        DatePicker
    },
    created() {
        this.$store.dispatch("AdvancePayment/setAdvancePayment");
        this.$store.dispatch("Employee/getEmployeeAll").then(res => {
            this.employeeAll = res;
        });
        this.$store.dispatch("AdvancePayment/clearFormData");
        this.$store.dispatch("AdvancePayment/clearSearch");
    },
    computed: {
        ...mapState({
            AdvancePaymentList: state => {
                return state.AdvancePayment.AdvancePaymentList
            },
            dataPaginate: state => {
                return state.AdvancePayment.dataPaginate;
            },
            search: state => {
                return state.AdvancePayment.search;
            },
        })
    },
    data() {
        return {
            employeeAll: [],
            id: "",
            event_submit: false,
            item:{}
        };
    },
    methods: {
        canViewSuperAdmin,
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        saveAdvancePayment(submitData) {
            if (submitData == 0) {
                this.$store.dispatch("AdvancePayment/clearFormData");
            } else {
                this.$store.dispatch('AdvancePayment/saveAdvancePayment', {
                    id: submitData.id,
                    data: submitData
                }).then(() => {
                    this.getAdvancePaymentList();
                })
                this.$store.dispatch("AdvancePayment/clearFormData");
            }
            this.$store.dispatch("AdvancePayment/setAdvancePayment");
            this.hideAdvancePaymentModal();
        },
        onEditAdvancePayment(submitData){
            if (submitData != 0) {
                this.$store.dispatch('AdvancePayment/saveAdvancePayment', {
                    id: submitData.id,
                    data: submitData
                }).then(() => {
                    this.getAdvancePaymentList();
                })
            }
            this.$refs.advance_payment_edit.hide();
        },
        showAdvancePaymentModal() {
            this.$refs.advance_payment.show();
        },
        hideAdvancePaymentModal() {
            this.$refs.advance_payment.hide();
        },
        showAdvancePaymentForm() {
            this.$refs.advance_payment_details.show();
        },
        hideAdvancePaymentForm() {
            this.$refs.advance_payment_details.hide();
        },
        showAdvancePaymentDetail(submitData) {
            if (submitData == 0) {
                this.hideAdvancePaymentForm();
            }
        },
        showAdvancePaymentDetails(id) {
            let data = {
                page: 1,
                id: id
            };
            this.$store.dispatch("AdvancePayment/showAdvancePaymentById", id).then(() => {
                this.$store.dispatch("AdvancePaymentDetails/showAdvancePaymentDetailsById", data);
                this.showAdvancePaymentForm();
            });
        },
        createAdvancePayment() {
            this.item = {}
            this.$store.dispatch("AdvancePayment/clearFormData").then(() => {
                this.showAdvancePaymentModal();
            })
        },
        showPaymentDetails(i) {
            this.item = this.AdvancePaymentList[i]
            this.$refs.advance_payment_edit.show();
        },
        getAdvancePaymentList() {
            const page = this.dataPaginate.current_page;
            //paginate search
            if (this.event_submit) {
                //console.log('search')
                if (this.search.date) {
                    this.search.date = moment(this.search.date).format("YYYY-MM-DD");
                } else {
                    this.search.date = "";
                }
                if (this.search.employee) {
                    this.search.employee_id = this.search.employee.id
                } else {
                    this.search.employee = "";
                }
                let data = {
                    page: page,
                    employee_id: this.search.employee_id,
                    date: this.search.date
                };
                this.$store.dispatch("AdvancePayment/search", data)
            }
            //paginate get data
            else {
                this.$store.dispatch('AdvancePayment/setAdvancePayment', page)
            }

        },
        searchAdvancePayment() {
            this.event_submit = true;
            //change date format
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            if (this.search.employee) {
                this.search.employee_id = this.search.employee.id
            } else {
                this.search.employee = "";
            }
            //console.log(this.search);

            this.$store.dispatch("AdvancePayment/search", this.search)
        },
        editAdvancePayment(id) {
            this.$store.dispatch("AdvancePayment/showAdvancePaymentById", id).then(() => {
                this.$refs.advance_payment.show();
            })
        },

    }
}
</script>

<style scoped>

</style>
